<template>
  <template-post-item></template-post-item>
</template>

<script lang="ts">

import templatePostItem from '@/app-template/lib/components/PostItem.vue';

export default {
  components: { templatePostItem },
};
</script>